// import BaseAutocomplete2 from "./BaseAutocomplete2.vue"
// import BaseCard from "./BaseCard.vue"
// import BaseCheckbox from "./BaseCheckbox.vue"
// import BaseChip from "./BaseChip.vue"
// import BaseChipGroup from "./BaseChipGroup.vue"
// import BaseContainer from "./BaseContainer.vue"
// import BaseDialog from "./BaseDialog.vue"
// import BaseDisclaimer from "./BaseDisclaimer.vue"
// import BaseDivider from "./BaseDivider.vue"
// import BaseDropdown from "./BaseDropdown.vue"
// import BaseEmpty from "./BaseEmpty.vue"
// import BaseExpansionPanel from "./BaseExpansionPanel.vue"
// import BaseImg from "./BaseImg.vue"
// import BaseInput from "./BaseInput.vue"
// import BaseInput2 from "./BaseInput2.vue"
// import BaseInputError from "./BaseInputError.vue"
// import BaseModal from "./BaseModal.vue"
// import BaseOTP from "./BaseOTP.vue"
// import BasePagination from "./BasePagination.vue"
// import BaseRadio from "./BaseRadio.vue"
// import BaseRadioGroup from "./BaseRadioGroup.vue"
// import BaseSkeletonPath from "./BaseSkeletonPath.vue"
// import BaseSwiper from "./BaseSwiper.vue"
// import BaseTextarea from "./BaseTextarea.vue"
// import Stencil from "./Stencil.vue"

export default [
    'BaseAutocomplete2',
    'BaseCard',
    'BaseCheckbox',
    'BaseChip',
    'BaseChipGroup',
    'BaseContainer',
    'BaseDialog',
    'BaseDisclaimer',
    'BaseDivider',
    'BaseDropdown',
    'BaseEmpty',
    'BaseExpansionPanel',
    'BaseImg',
    'BaseInput',
    'BaseInput2',
    'BaseInputError',
    'BaseModal',
    'BaseOTP',
    'BasePagination',
    'BaseRadio',
    'BaseRadioGroup',
    'BaseSkeletonPath',
    'BaseSwiper',
    'BaseTextarea',
    'Stencil',
]